module.exports = __webpack_public_path__ + "static/rightink-a852dacec4fd64d49f1d482264006232.png";